// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d92be775","977":"f6583acf"}[chunkId] + ".chunk.js";
};